import { Button } from '@repo/ui/components'
import { useTranslate } from '../../hooks'
import type { AdvancedTradeBoxSubmitButtonProps } from './advanced-trade-box.types'
import { FeatureFlag } from '../../components'

export const AdvancedTradeBoxSubmitButton = ({
  tab,
  onClick,
  isLoading = false,
}: AdvancedTradeBoxSubmitButtonProps) => {
  const { t } = useTranslate()

  const buttonText = tab === 'buy' ? t('order_buy') : t('order_sell')

  return (
    <FeatureFlag flagKey={['advanced-trade', 'value', tab, 'submit_button']}>
      <Button
        type='button'
        size='sm'
        color={tab === 'buy' ? 'positive' : 'negative'}
        className='w-full'
        onClick={onClick}
        loading={isLoading}
      >
        {buttonText}
      </Button>
    </FeatureFlag>
  )
}
